"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizableWidth = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _HBSidePanel = require("../HBSidePanel.consts");
var useResizableWidth = exports.useResizableWidth = function useResizableWidth(_ref) {
  var initialWidth = _ref.initialWidth,
    isResizable = _ref.isResizable,
    minWidth = _ref.minWidth;
  var _useState = (0, _react.useState)(initialWidth),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentWidth = _useState2[0],
    setCurrentWidth = _useState2[1];
  var startClientXRef = (0, _react.useRef)(null);
  var handleMouseMove = (0, _react.useCallback)(function (event) {
    if (startClientXRef.current === null) {
      return;
    }
    var desiredWidth = window.innerWidth - event.clientX;
    var min = minWidth !== null && minWidth !== void 0 ? minWidth : 0;
    setCurrentWidth(desiredWidth < min ? min : desiredWidth);
  }, [minWidth]);
  (0, _react.useEffect)(function () {
    if (!isResizable) {
      return;
    }
    var _handleMouseUp = function handleMouseUp() {
      var _document$querySelect;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', _handleMouseUp);
      document.body.style.userSelect = '';
      (_document$querySelect = document.querySelector(".".concat(_HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME))) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove(_HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME);
      startClientXRef.current = null;
    };
    var handleMouseDown = function handleMouseDown(event) {
      event.preventDefault();
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', _handleMouseUp);
      document.body.style.userSelect = 'none';
      event.currentTarget.classList.add(_HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME);
      startClientXRef.current = event.clientX;
    };
    var resizeHandle = document.querySelector(".".concat(_HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME));
    resizeHandle === null || resizeHandle === void 0 || resizeHandle.addEventListener('mousedown', handleMouseDown);
    return function () {
      resizeHandle === null || resizeHandle === void 0 || resizeHandle.removeEventListener('mousedown', handleMouseDown);
      document.body.style.userSelect = '';
    };
  }, [isResizable, handleMouseMove]);
  return [currentWidth];
};
//# sourceMappingURL=useResizableWidth.js.map